const FIREBASE_CONST = {
  USER_NOT_FOUND: 'auth/user-not-found',
  EMAIL_ALREADY_EXISTS: 'auth/email-already-in-use',
  INVALID_CREDENTIAL: 'auth/invalid-credential',
  FILE_NOT_FOUND: 'storage/object-not-found',
  TOO_MANY_REQUESTS: 'auth/too-many-requests',
  INVALID_EMAIL: 'auth/invalid-email',
  WRONG_PASSWORD: 'auth/wrong-password',
}

export default FIREBASE_CONST
